import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { Observable } from 'rxjs/Rx';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SharedService} from "../../shared/shared.service";
import {SettingsCashregService} from "./settings-cashreg.service";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {DtoDiscountBaseItems} from "./models/DtoDiscountBaseItems";
import {DtoQuantityDiscount} from "./models/DtoQuantityDiscount";

@Component({
    selector: 'quantity-discount',
    template: require('./quantity-discount.component.html'),
    styles: [require('./quantity-discount.component.css')]
})
@AutoUnsubscribe()

export class QuantityDiscountComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup;
    dtoObject: DtoQuantityDiscount;
    baseItems: DtoDiscountBaseItems;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService) {
    }

    ngOnInit() {
        this.form = this.fb.group({
            daysFrom: ['', [SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateOverlap.bind(this))]],
            daysUntill: [null,[SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateOverlap.bind(this))]],
            discount: [null, [SharedValidators.customNumberRequired]],
            type: [null, [SharedValidators.customRequired]]
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (this.id > 0) {
            this.ds.getQuantityDiscountById(this.id)
                .subscribe(response => {
                    this.dtoObject = response;
                    this.getBaseItems();
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                });
        }
        else {
            this.dtoObject = {
                id: 0
            };
            this.getBaseItems();

            if (this.copyFromId > 0) {
                this.ds.getQuantityDiscountById(this.copyFromId)
                    .subscribe(response => {
                        this.dtoObject.type = response.type;
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    });
            }
            else {
                this.fs.patchDtoToForm(this.dtoObject, this.form);
            }
        }
    }

    getBaseItems() {
        this.ds.getDiscountBaseItems(false).subscribe(response => {
            this.baseItems = response;
        });
    }

    validateOverlap(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && control.dirty && control.value != null) {
                this.ds.checkQuantityDiscountOverlap(this.dtoObject.id, control.value)
                    .subscribe((response: boolean) => {
                        observer.next(!response ? null : { daysOverlap: true });
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    validateDays() {
        if (this.form.value.daysUntill <= this.form.value.daysFrom) {
            this.ss.message('Het aantal dagen vanaf kan niet gelijk of groter zijn dan het aantal dagen tot');
            return false;
        }
        return true;
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid && this.validateDays()) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.ds.saveQuantityDiscount(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/quantity-discount.component.ts